var _defs, _circle, _g, _circle2, _path, _g2, _polygon, _circle3, _path2, _circle4, _path3, _circle5, _path4, _circle6, _path5, _circle7, _path6, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSummary = function SvgSummary(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "principal",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 205.39 205.16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7390b8;}.cls-2{fill:#3874b9;}.cls-3{fill:#a0a9b7;}.cls-4{fill:none;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 102.69,
    cy: 102.58,
    r: 102
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "screen"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_788",
    className: "cls-3",
    x: 32.21,
    y: 55.42,
    width: 137.62,
    height: 94.44,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_965",
    className: "cls-1",
    d: "m161.27,71.76H40.75c-.5,0-.9-.4-.9-.9s.4-.9.9-.9h120.52c.5,0,.9.4.9.9s-.4.9-.9.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_966",
    className: "cls-1",
    d: "m140.12,63.67h-6.3c-.25,0-.45-.2-.45-.45,0-.25.2-.45.45-.45h6.3c.25,0,.45.2.45.45s-.2.45-.45.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_967",
    className: "cls-1",
    d: "m158.11,63.22l2.1-1.94c.18-.18.18-.46,0-.64h0c-.17-.18-.45-.18-.62,0,0,0,0,0,0,0l-2.17,1.97-2.15-1.97c-.18-.18-.46-.18-.64,0,0,0,0,0,0,0-.17.18-.17.46,0,.64l2.1,1.92-2.1,1.92c-.17.18-.17.46,0,.64.09.09.21.14.33.14.11,0,.22-.04.31-.12l2.16-1.98,2.17,1.98c.08.08.19.12.3.12.13,0,.25-.05.33-.14.18-.18.18-.46,0-.64h0s-2.11-1.89-2.11-1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_968",
    className: "cls-1",
    d: "m150.47,65.65h-6.3v-5.4h6.3v5.4Zm-5.4-.9h4.5v-3.6h-4.5v3.6Z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 147.69,
    cy: 120.64,
    r: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m147.69,106.64c-7.72,0-14,6.28-14,14s6.28,14,14,14,14-6.28,14-14-6.28-14-14-14Zm11.72,11.46l-10.9,1.56-2.89-10.82c.67-.12,1.36-.19,2.07-.19,5.74,0,10.55,4.06,11.72,9.46Zm-11.72,14.54c-6.62,0-12-5.38-12-12,0-5.21,3.35-9.65,8-11.3l3.35,12.55,12.62-1.81c0,.19.03.37.03.56,0,6.62-5.38,12-12,12Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "bar"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m120.79,137.06h.13s-1.92,0-1.92,0v-17.56c0-.72-.59-1.31-1.31-1.31h-6.68c-.72,0-1.31.59-1.31,1.31v17.56h-5.7v-17.56c0-.72-.59-1.31-1.31-1.31h-6.68c-.72,0-1.31.59-1.31,1.31v17.54h-5.63v-31.17c0-.64-.52-1.15-1.15-1.15h-6.98c-.64,0-1.15.52-1.15,1.15v31.16h-5v-24.75c0-.64-.52-1.15-1.15-1.15h-6.93c-.64,0-1.15.52-1.15,1.15v24.75h-4.96v-16.02c0-.64-.51-1.15-1.15-1.15h-6.93c-.64,0-1.15.52-1.15,1.15v16.02h-3.8v-38.86c0-.64-.52-1.15-1.15-1.15s-1.15.52-1.15,1.15v40.02c0,.64.51,1.16,1.15,1.16h41.54l32.87.03c.64,0,1.15-.52,1.15-1.16,0-.64-.52-1.15-1.15-1.15Zm-62.58-.03h-4.62v-14.87h4.62v14.87Zm14.25,0h-4.62v-23.59h4.62v23.59Zm14.29,0h-4.67v-30.01h4.67v30.01Zm24.94-16.85h5.3v16.87h-5.3v-16.87Zm-15,0h5.3v16.86h-5.3v-16.86Z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "101.2 95.51 85.12 84.38 67.51 95.49 49.72 86.02 50.66 84.26 67.42 93.18 85.17 81.98 101.33 93.16 115.03 85.65 115.99 87.4 101.2 95.51"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 50.19,
    cy: 85.14,
    r: 4.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m50.19,89.64c-2.48,0-4.5-2.02-4.5-4.5s2.02-4.5,4.5-4.5,4.5,2.02,4.5,4.5-2.02,4.5-4.5,4.5Zm0-7c-1.38,0-2.5,1.12-2.5,2.5s1.12,2.5,2.5,2.5,2.5-1.12,2.5-2.5-1.12-2.5-2.5-2.5Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 67.19,
    cy: 94.14,
    r: 4.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m67.19,98.64c-2.48,0-4.5-2.02-4.5-4.5s2.02-4.5,4.5-4.5,4.5,2.02,4.5,4.5-2.02,4.5-4.5,4.5Zm0-7c-1.38,0-2.5,1.12-2.5,2.5s1.12,2.5,2.5,2.5,2.5-1.12,2.5-2.5-1.12-2.5-2.5-2.5Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 85.19,
    cy: 83.14,
    r: 4.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m85.19,87.64c-2.48,0-4.5-2.02-4.5-4.5s2.02-4.5,4.5-4.5,4.5,2.02,4.5,4.5-2.02,4.5-4.5,4.5Zm0-7c-1.38,0-2.5,1.12-2.5,2.5s1.12,2.5,2.5,2.5,2.5-1.12,2.5-2.5-1.12-2.5-2.5-2.5Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 101.19,
    cy: 94.14,
    r: 4.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m101.19,98.64c-2.48,0-4.5-2.02-4.5-4.5s2.02-4.5,4.5-4.5,4.5,2.02,4.5,4.5-2.02,4.5-4.5,4.5Zm0-7c-1.38,0-2.5,1.12-2.5,2.5s1.12,2.5,2.5,2.5,2.5-1.12,2.5-2.5-1.12-2.5-2.5-2.5Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 115.19,
    cy: 86.14,
    r: 4.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m115.19,90.64c-2.48,0-4.5-2.02-4.5-4.5s2.02-4.5,4.5-4.5,4.5,2.02,4.5,4.5-2.02,4.5-4.5,4.5Zm0-7c-1.38,0-2.5,1.12-2.5,2.5s1.12,2.5,2.5,2.5,2.5-1.12,2.5-2.5-1.12-2.5-2.5-2.5Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "text"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m160.19,82.14h-26c-.55,0-1-.45-1-1s.45-1,1-1h26c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m143.19,88.64h-9c-.55,0-1-.45-1-1s.45-1,1-1h9c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m160.19,88.64h-11c-.55,0-1-.45-1-1s.45-1,1-1h11c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m140.19,95.14h-6c-.55,0-1-.45-1-1s.45-1,1-1h6c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m153.19,95.14h-9c-.55,0-1-.45-1-1s.45-1,1-1h9c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSummary);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "summary.8c96fce65fe9c10d510a24420ad40e84.svg";